var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.392 19.8C12.392 20.3835 12.1546 20.9431 11.7321 21.3556C11.3095 21.7682 10.7364 22 10.1389 22C9.54133 22 8.96825 21.7682 8.54572 21.3556C8.12318 20.9431 7.8858 20.3835 7.8858 19.8H12.392ZM10.1389 0C10.4377 0 10.7242 0.115892 10.9355 0.322183C11.1467 0.528472 11.2654 0.808262 11.2654 1.1V2.288C14.4648 2.816 16.8981 5.533 16.8981 8.8V15.4L20.2778 18.7H0L3.37963 15.4V8.8C3.37963 5.533 5.81296 2.816 9.01235 2.288V1.1C9.01235 0.808262 9.13104 0.528472 9.3423 0.322183C9.55357 0.115892 9.84011 0 10.1389 0Z",
    fill: "#D7DF23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1529 7H9.12516V10H6.0835V12H9.12516V15H11.1529V12H14.1946V10H11.1529V7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellGreen);
export default __webpack_public_path__ + "static/media/notificationBellGreen.f28a1c01c0af58245cfeac549970061e.svg";
export { ForwardRef as ReactComponent };